import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import React from 'react'



// const data = [
//   { id: 1, name: 'Snow', district: 'Jon', subdistrict: 'dsf',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 2, name: 'sdc', district: 'Jon', subdistrict: 'cx',dsname:'ram',mobile:'1234567890' ,email:"demo@gmail.com"},
//   { id: 3, name: 'Snow', district: 'Jon', subdistrict: 'ew',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 4, name: 'dc', district: 'Jon', subdistrict: 'sdf',dsname:null ,mobile:'1234567890',email:"demo@gmail.com"},
//   { id: 5, name: 'ds', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 6, name: 'as', district: 'Jon', subdistrict: 'ds',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 7, name: 'ds', district: 'Jon', subdistrict: 'zxc',dsname:null,mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 8, name: 'asd', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
//   { id: 9, name: 'zxc', district: 'Jon', subdistrict: 'zxc',dsname:'ram',mobile:'1234567890',email:"demo@gmail.com" },
// ];

export default function AddDevice(props) {
    // const[Selected,setSelected]=useState(null)
    console.log(props);
    const data = props.data

    const handleButtonClick = (productId) => {
      console.log(data);
      console.log(productId);
      setSelected(data.find((item)=>item._id===productId))
      props.setSelected(true)
    }
    // const handleBack=()=>{
    //     setSelected(null)
    //     props.setSelected(false)
    // }
    // console.log(Selected);
    const columns = [
        { field: 'vendor_name', headerName: 'Vendor Name', width: 200 },
        {
          field: 'vendor_code',
          headerName: 'Vendor Code',
          width: 200,
          editable: true,
        },
        {
          field: 'company_name',
          headerName: 'Comapany Name',
          width: 150,
          editable: true,
        },
        {
          field: 'gst',
          headerName: 'GST No',
          width: 110,
          editable: true,
        },
        {
          field: 'mobile',
          headerName: 'Mobile',
          width: 400,
          editable: true,
        },
        {
          field: 'bank_name',
          headerName: 'Bank Name',
          width: 400,
          editable: true,
        },
        {
          field: 'ifsc',
          headerName: 'IFSC Code',
          width: 400,
          editable: true,
        },
        {
          field: 'status',
          headerName: 'Status',
          width: 400,
          editable: true,
        },
        {
          field: 'action',
          headerName: 'Action',
          width: 110,
          renderCell: (params) => {
            return (
              <Button variant="contained" color="secondary" onClick={() => handleButtonClick(params.row._id)}>
                {props.status==="mapped"?"Edit":"Map"} 
              </Button>
            );
          },
        },
        
      ];

   
  return (
    <Box sx={{ height: 400, width: '100%' }}>
    {
        
        <DataGrid
        rows={data?data:[]}
        columns={columns}
        getRowId={(item)=>item._id}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    }
     
    </Box>
  );
}